module.exports = __webpack_public_path__ + "assets/img/xinFen2.4d045813.png";